import { useUserCountrySelector } from "@nf/common";
import { useCountry } from "./useCountry";

export const useUserCountry = () => {
  const { Data: userCountry, IsProcessing, Error } = useUserCountrySelector();
  const country = useCountry();

  return {
    data: userCountry,
    loading: IsProcessing,
    error: Error,
    isUserCountrySupported:
      userCountry !== null &&
      userCountry?.toUpperCase() === country?.toUpperCase(),
  };
};
